import _defineProperty from "/Users/lianzhaocheng/Downloads/workplace/bieyang/web/bybieyang-home/product-search/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import React from 'react';
import classNames from 'classnames';
var classPrefix = "adm-slider";

var Ticks = function Ticks(_ref) {
  var points = _ref.points,
      max = _ref.max,
      min = _ref.min,
      upperBound = _ref.upperBound,
      lowerBound = _ref.lowerBound;
  var range = max - min;
  var elements = points.map(function (point) {
    var _classNames;

    var offset = "".concat(Math.abs(point - min) / range * 100, "%");
    var isActived = point <= upperBound && point >= lowerBound;
    var style = {
      left: offset
    };
    var pointClassName = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(classPrefix, "-tick"), true), _defineProperty(_classNames, "".concat(classPrefix, "-tick-active"), isActived), _classNames));
    return React.createElement("span", {
      className: pointClassName,
      style: style,
      key: point
    });
  });
  return React.createElement("div", {
    className: "".concat(classPrefix, "-ticks")
  }, elements);
};

export default Ticks;